import ROLES from '@/utils/roles';
import TOP_BARS from '@topBars';
import FOOTERS from '@footers';
let routes = [
  {
    path: '/poster/live-reservation/bpc',
    name: 'poster-live-reservation-bpc',
    meta: {
      title: 'BPC 直播预约',
      footer: FOOTERS.NULL
    },
    component: () => import('@/views/Poster/LiveReservation/Bpc')
  },
  {
    path: '/poster/live-reservation/hsylc',
    name: 'poster-live-reservation-hsylc',
    meta: {
      title: 'HSYLC 直播预约',
      footer: FOOTERS.NULL
    },
    component: () => import('@/views/Poster/LiveReservation/Hsylc')
  },
  /**
   * @description 小程序海报生成页
   * @function /poster/talent-hunt 小程序海报生成页
   * @param { Component } TalentHunt views/Poster/TalentHunt
   * @param { Name } pathname /poster-talent-hunt
   */
  {
    path: '/poster/talent-hunt',
    name: 'poster-talent-hunt',
    meta: {
      title: 'talent hunt'
    },
    component: () => import('@/views/Poster/TalentHunt')
  },
  /**
   * @description hsylc录取喜报
   * @function /poster/enroll hsylc录取喜报
   * @param { Component } Info views/Poster/Enroll
   * @param { Name } pathname /poster-enroll
   */
  {
    path: '/poster/enroll',
    name: 'poster-enroll',
    meta: {
      title: '录取喜报'
    },
    component: () => import('@/views/Poster/Enroll')
  },
  /**
   * @description hxweek喜报（SPA 预览；截图服务请用 /poster/hxweek/index.html?school=）
   * @function /poster/hxweek/:school
   */
  {
    path: '/poster/hxweek/:school',
    name: 'poster-hxweek',
    meta: {
      title: 'hxweek喜报'
    },
    component: () => import('@/views/Poster/HXWeek')
  },
  {
    path: '/poster/admission/:id',
    name: 'poster-admission',
    meta: {
      title: '录取喜报'
    },
    component: () => import('@/views/Poster/Admission')
  },
  {
    path: '/poster/admission-si/:id?',
    name: 'poster-admission-si',
    meta: {
      title: '高中实习生预录取喜报'
    },
    component: () => import('@/views/Poster/Admission/SI')
  },
  {
    path: '/poster/admission-2/:id/:school?',
    name: 'poster-admission-2',
    meta: {
      title: '录取喜报'
    },
    component: () => import('@/views/Poster/AdmissionRD')
  },
  /**
   * @description 荣誉学生喜报（SPA 预览；截图服务请用 /poster/honor/index.html?school=）
   * @function /poster/honor/:school?
   */
  {
    path: '/poster/honor/:school?',
    name: 'poster-honor',
    meta: {
      title: '学生荣誉喜报'
    },
    component: () => import('@/views/Poster/Honor')
  },
  {
    path: '/poster/sa/:id?/:school?',
    name: 'poster-sa',
    meta: {
      title: '学生荣誉喜报-SA'
    },
    component: () => import('@/views/Poster/Sa')
  },
  {
    path: '/poster/dl/:school',
    name: 'poster-dl',
    meta: {
      title: '学生荣誉喜报-DL'
    },
    component: () => import('@/views/Poster/DL')
  }, {
    path: '/wecom/add',
    name: 'wecom-add',
    meta: {
      title: '添加小助手'
    },
    component: () => import('@/views/WeCom/Add')
  }, {
    path: '/wecom/place-add',
    name: 'wecom-place-add',
    meta: {
      title: '添加会场老师'
    },
    component: () => import('@/views/WeCom/PlaceAdd')
  }, {
    path: '/grade/poster/detail',
    name: 'grade-poster-detail',
    meta: {
      title: '成绩单海报详情'
    },
    component: () => import('@/views/student/Manager/Grade/Poster/Detail')
  },
];
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta, {
    topBar: TOP_BARS.NULL
  });
  return ret;
});
export default routes;
